<div class="games-area-container flex items-center">
  <button
    type="button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="handleGamesToggle()"
    class="games button padding-x-12 h-32 rounded-6 button--style-dropdown"
    [class.active]="isOpen()"
  >
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/icons/games/games.svg"
    />
    <span>Games</span>
    <svg-icon
      class="flex items-center justify-center s-16 indicator"
      src="assets/icons/ui/arrow.svg"
    />
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpenGamesPopover() && !isMobile()"
    (detach)="isOpenGamesPopover.set(false)"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
  >
    <div
      class="games-menu dropdown--items-container header-dropdown"
      (clickOutside)="isOpenGamesPopover.set(false)"
    >
      @for (game of games(); track game.name) {
      <div
        [routerLink]="game.link"
        class="games-item dropdown--item"
        [class.active]="game.isActive"
      >
        <div class="link flex items-center">
          <svg-icon class="flex items-center justify-center s-24" [src]="game.icon"></svg-icon>
          <div class="body">
            <span class="title">{{ game.name }}</span>
            <span class="description">{{ game.description }}</span>
          </div>
        </div>
        <button
          type="button"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setGames(game, $index)
          "
          class="button s-32 mark-button"
          [class.active]="game.isActive"
        >
          <span class="mark"></span>
        </button>
      </div>
      }
    </div>
  </ng-template>

  <div class="selected-games flex items-center">
    @for (game of selectedGames(); track game.name) {
    <app-header-favorite-game
      [game]="game"
      [value]="
        game.name === 'Case Battles' && game.showValue
          ? caseBattlesService.gamesPrice()
          : game.name === 'Jackpot' && game.showValue
          ? jackpotService.totalValue()
          : game.name === 'King' && game.showValue
          ? kingService.game()?.king?.value ?? 0
          : game.name === 'King New' && game.showValue
          ? kingNewService.game()?.king?.value ?? 0
          : game.name === 'Coinflip' && game.showValue
          ? coinflipService.totalValue()
          : null
      "
    ></app-header-favorite-game>
    }
  </div>
</div>

<div class="games-mobile-backdrop" [class.games-mobile-backdrop--open]="uiService.isShowGames()" (click)="uiService.toggleMobileState('games')"></div>
<div class="games-mobile-panel" [class.games-mobile-panel--open]="uiService.isShowGames()">
  @for (game of games(); track game.name) {
  <div
    [routerLink]="game.link"
    class="games-item dropdown--item"
    [class.active]="game.isActive"
  >
    <div class="link flex items-center">
      <svg-icon class="flex items-center justify-center s-24" [src]="game.icon"></svg-icon>
      <div class="body">
        <span class="title">{{ game.name }}</span>
        <span class="description">{{ game.description }}</span>
      </div>
    </div>
    <button
      type="button"
      (click)="
        $event.preventDefault();
        $event.stopPropagation();
        setGames(game, $index)
      "
      class="button s-32 mark-button"
      [class.active]="game.isActive"
    >
      <span class="mark"></span>
    </button>
  </div>
  }
</div>
